import { type TAudioPaginated } from '@core/models'
import { useCollectionAudios } from '@features/collection'

import { useCollectionScreenAudios } from '../store/useCollectionScreenAudios'
import { useCollectionScreenCollection } from '../store/useCollectionScreenCollection'

export const useCollectionTracklist = (): TAudioPaginated => {
    const { authorUsername, slug } = useCollectionScreenCollection()
    const loaderAudios = useCollectionScreenAudios()
    const { data } = useCollectionAudios({
        username: authorUsername,
        slug,
        page: loaderAudios.pagination.page,
    })

    return data ?? loaderAudios
}
